export const ALLOWED_FILE_EXT = ['xlsx'];
export const MAX_EMPTY_STREAK = 3;
export const ROWS_PER_PAGE = 10;